module.exports = __webpack_public_path__ + "static/projects-nightrider-view-77f0b8cdd2bb0e17f17e8eecf8286d6e.jpg";